import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { actions } from '../../utils/constants';
import { createAdmin, deleteAdmin, fetchAdmins, withRetry } from '../../utils/common-functions';

function* fetchAllAdmins() {
    yield put({ type: actions.ADMINS_FETCH_LOADING, payload: { loading: true } });
    try {
        const admins = yield call(withRetry(fetchAdmins));
        yield put({ type: actions.ADMINS_FETCHED, payload: admins.data });
    } catch (e) {
        yield put({ type: actions.REQUEST_ERROR, payload: { message: 'Os administradores não puderam ser carregados. Tente recarregar a página' } });
    }
    yield put({ type: actions.ADMINS_FETCH_LOADING, payload: { loading: false } });
}

function* addAdmin({ payload }) {
    try {
        yield createAdmin(payload);
        yield put({ type: actions.ADMIN_CREATED, payload });
    } catch (e) {
        yield put({ type: actions.REQUEST_ERROR, payload: { message: 'As alterações não puderam ser salvas. Tente novamente' } });
    }
}

function* removeAdmin({ payload }) {
    try {
        yield deleteAdmin(payload);
        yield put({ type: actions.ADMIN_DELETED, payload });
    } catch (e) {
        yield put({ type: actions.REQUEST_ERROR, payload: { message: 'As alterações não puderam ser salvas. Tente novamente' } });
    }
}

export default function* courses() {
    yield takeLatest(actions.ASYNC_FETCH_ADMIN_DATA, fetchAllAdmins);
    yield takeLatest(actions.ASYNC_FETCH_ADMINS, fetchAllAdmins);
    yield takeEvery(actions.ASYNC_CREATE_ADMIN, addAdmin);
    yield takeEvery(actions.ASYNC_DELETE_ADMIN, removeAdmin);
}



// WEBPACK FOOTER //
// ./src/components/admins/admins.saga.js